import CommentType from '@/constants/comments/CommentType'
const {
  TaskGeneralComment,
  DisputeFollowUpCandidateExtendedShiftDuration,
  DisputeFollowUpCandidateReducedMealBreak,
  DisputeFollowUpCandidateStatedDidNotHappen,
} = CommentType

export default [
  TaskGeneralComment,
  DisputeFollowUpCandidateExtendedShiftDuration,
  DisputeFollowUpCandidateReducedMealBreak,
  DisputeFollowUpCandidateStatedDidNotHappen,
]
